import { Flex } from '@chakra-ui/react';
import React, { useState, useEffect, useRef } from 'react';
import { formConfig } from './config';
import { ReserveUnitFormBody } from './ReserveUnitFormBody';
import { Form } from 'react-final-form';
import { ReserveUnitFormPropTypes } from './ReserveUnitFormPropTypes';
import { containerStyles } from './constant';

export const ReserveUnitForm = ({
  onSubmitForm,
  ctaButtonConfig,
  showAltDetails,
  showMilitaryDetails,
  objCharges,
  lstRentalPeriods,
  lstInsuranceChoices,
  lstUnitTypes,
  intLeadDaysFrom,
  intLeadDaysTo,
  firstName = '',
  lastName = '',
  phone = '',
  email = '',
  addressLine1 = '',
  addressLine2 = '',
  city = '',
  state = '',
  zipCode = '',
  isReserve = false,
  selectedUnitType: initialUnitType,
  retrievedFormData,
  premium: retrievedPremium,
}: ReserveUnitFormPropTypes.IReserveFormProps) => {
  const [rentalCharges, setRentalCharges] = useState<any>(objCharges);
  const [selectedUnitType, setSelectedUnitType] = useState(initialUnitType || lstUnitTypes[0].UnitTypeID);
  const [selectedUnitTypeDescription, setUnitTypeDescription] = useState('');
  const [selectedRentalPeriod, setSelectedRentalPeriod] = useState(lstRentalPeriods[0].PeriodID);
  const [premium, setPremium] = useState(retrievedPremium || 0);
  const [reservationFee, setReservationFee] = useState<number | undefined>();
  const [monthlyRate, setMonthlyRate] = useState<number | undefined>();

  useEffect(() => {
    const unitType = lstUnitTypes.find((unitType) => unitType.UnitTypeID === selectedUnitType);
    if (unitType) {
      setUnitTypeDescription(unitType.Description);
      if (isReserve) {
        setReservationFee(unitType.ReservationFee);
        setMonthlyRate(unitType.MonthlyRate);
      }
    }
  }, [selectedUnitType]);

  const getPeriodDescription = (period: any, rentalPeriods: any) => {
    return rentalPeriods.reduce((accumulator: any, currentValue: any) => {
      if (currentValue.PeriodID == period) {
        return currentValue.PeriodDescription;
      }
      return accumulator;
    }, '')
  };


  const initialFormField = {
    firstName: firstName,
    lastName: lastName,
    phone: phone,
    email: email,
    addressLine1: addressLine1,
    addressLine2: addressLine2,
    city: city,
    state: state,
    zipCode: zipCode,
    driverLicenseNumber: '',
    driverLicenseExpiration: '',
    birthDate: '',
    militaryType: '',
    militaryBranch: '',
    militaryID: '',
    militaryDeployedDate: '',
    militaryDivision: '',
    militaryCommandingOfficer: '',
    militaryCommandingOfficerNumber: '',
    altFirstName: '',
    altLastName: '',
    altPhone: '',
    altEmail: '',
    altAddressLine1: '',
    altAddressLine2: '',
    altCity: '',
    altState: '',
    altZipCode: '',
    unitType: selectedUnitType,
    insuranceType: '',
    period: '',
  };
  return (
    <Flex {...containerStyles}>
      <Form
        onSubmit={(values) => {
          onSubmitForm({
            formData: values,
            rentalCharges: rentalCharges,
            unitTypeDescription: selectedUnitTypeDescription,
            isReserve,
            periodDescription: getPeriodDescription(values.period, lstRentalPeriods),
            premium,
            reservationFee: reservationFee || 0,
            monthlyRate,
            unitTypeId: selectedUnitType
          })
        }}
        initialValues={(retrievedFormData && { ...retrievedFormData }) || { ...initialFormField }}
        render={(currentFormProps) => {
          const { handleSubmit } = currentFormProps;
          return (
            <form onSubmit={handleSubmit} >
              <ReserveUnitFormBody
                formConfig={formConfig(intLeadDaysFrom, intLeadDaysTo)}
                showAltDetails={showAltDetails}
                showMilitaryDetails={showMilitaryDetails}
                onSubmitForm={onSubmitForm}
                ctaButtonConfig={ctaButtonConfig}
                currentFormProps={currentFormProps}
                objCharges={objCharges}
                lstRentalPeriods={lstRentalPeriods}
                lstUnitTypes={lstUnitTypes}
                lstInsuranceChoices={lstInsuranceChoices}
                rentalCharges={rentalCharges}
                setRentalCharges={setRentalCharges}
                isReserve={isReserve}
                selectedUnitType={selectedUnitType}
                setSelectedUnitType={setSelectedUnitType}
                selectedRentalPeriod={selectedRentalPeriod}
                setSelectedRentalPeriod={setSelectedRentalPeriod}
                retrievedFormData={retrievedFormData}
                premium={premium}
                setPremium={setPremium}
                reservationFee={reservationFee}
                monthlyRate={monthlyRate}
              />
            </form>
          );
        }}
      />
    </Flex>
  );
};
